import { render } from "./AvailablePropertiesPagableList.vue?vue&type=template&id=4d14e60e"
import script from "./AvailablePropertiesPagableList.vue?vue&type=script&lang=js"
export * from "./AvailablePropertiesPagableList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__